import { render, staticRenderFns } from "./PageThankyou.vue?vue&type=template&id=607827ef&"
import script from "./PageThankyou.vue?vue&type=script&lang=js&"
export * from "./PageThankyou.vue?vue&type=script&lang=js&"
import style0 from "./PageThankyou.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports